import React, { useEffect, useState } from "react";
import { renderpageapi } from "./hooks/apis";
import { useSelector, useDispatch } from "react-redux";
import axios from "axios";
import { API_BASE_URL } from "../../../../config";

const Rendernow = () => {
  const getRenderGoals = async () => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/getRenderGoals`
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching render goals:", error);
      throw error;
    }
  };

  useEffect(() => {
    const fetchRenderGoals = async () => {
      try {
        const data = await getRenderGoals();
        console.log("Fetched render goals:", data);
        setLink({
          ...data,
          links: data.link || "",
        });
      } catch (err) {
        console.error("Error fetching render goals:", err);
      }
    };

    fetchRenderGoals();
  }, []);

  const [link, setLink] = useState({
    links: "",
    arcwareShareId: "",
    arcwareProjectId: "",
    arcwareShareIdDev: "",
    arcwareProjectIdDev: "",
    publicDownloadUrl: "",
  });

  const response = useSelector((state) => state.adminReducer.render_message);
  const dispatch = useDispatch();

  const handlesubmit = (e) => {
    e.preventDefault();
    renderpageapi(link, dispatch);
    setLink("");
  };

  return (
    <section
      className="my-3"
      style={{
        borderBottom: "0.2rem solid rgb(25, 118, 210)",
        borderRadius: "8px",
      }}
    >
      {response === "show" && (
        <div
          className="alert alert-success mt-2 text-center font-weight-bold"
          role="alert"
        >
          Changes are successfully applied
        </div>
      )}
      {response === "no_show" && (
        <div className="alert alert-danger" role="alert">
          Some Error occured
        </div>
      )}

      <section className="row my-3 justify-content-end mx-1">
        <button
          type="submit"
          style={{ backgroundColor: "#1565c0", color: "white" }}
          className="my-2 py-2 px-3 rounded font-weight-bold shadow-lg oncea-button"
          onClick={handlesubmit}
        >
          Submit
        </button>
      </section>

      <section className="row my-3">
        <header
          className="col-lg col-12 text-left h5 bannerfont ml-3"
          style={{ fontWeight: 600 }}
        >
          Arcware Share ID - Production
        </header>
        <form className="col d-flex flex-column justify-content-left align-items-left shadow-md my-1 rounded">
          <input
            type="text"
            name="arcwareShareId"
            className="w-100 px-2 py-1"
            value={link.arcwareShareId}
            onChange={(e) =>
              setLink((v) => ({ ...v, arcwareShareId: e.target.value }))
            }
          />
        </form>
      </section>

      <section className="row my-3">
        <header
          className="col-lg col-12 text-left h5 bannerfont ml-3"
          style={{ fontWeight: 600 }}
        >
          Arcware Project ID - Production
        </header>
        <form className="col d-flex flex-column justify-content-left align-items-left shadow-md my-1 rounded">
          <input
            type="text"
            name="arcwareProjectId"
            className="w-100 px-2 py-1"
            value={link.arcwareProjectId}
            onChange={(e) =>
              setLink((v) => ({ ...v, arcwareProjectId: e.target.value }))
            }
          />
        </form>
      </section>

      <section className="row my-3">
        <header
          className="col-lg col-12 text-left h5 bannerfont ml-3"
          style={{ fontWeight: 600 }}
        >
          Arcware Share ID - Development
        </header>
        <form className="col d-flex flex-column justify-content-left align-items-left shadow-md my-1 rounded">
          <input
            type="text"
            name="arcwareShareIdDev"
            className="w-100 px-2 py-1"
            value={link.arcwareShareIdDev}
            onChange={(e) =>
              setLink((v) => ({ ...v, arcwareShareIdDev: e.target.value }))
            }
          />
        </form>
      </section>

      <section className="row my-3">
        <header
          className="col-lg col-12 text-left h5 bannerfont ml-3"
          style={{ fontWeight: 600 }}
        >
          Arcware Project ID - Development
        </header>
        <form className="col d-flex flex-column justify-content-left align-items-left shadow-md my-1 rounded">
          <input
            type="text"
            name="arcwareProjectIdDev"
            className="w-100 px-2 py-1"
            value={link.arcwareProjectIdDev}
            onChange={(e) =>
              setLink((v) => ({ ...v, arcwareProjectIdDev: e.target.value }))
            }
          />
        </form>
      </section>

      <section className="row my-3">
        <header
          className="col-lg col-12 text-left h5 bannerfont ml-3"
          style={{ fontWeight: 600 }}
        >
          Public Download URL
        </header>
        <form className="col d-flex flex-column justify-content-left align-items-left shadow-md my-1 rounded">
          <input
            type="text"
            name="monday.com"
            className="w-100 px-2 py-1"
            value={link.publicDownloadUrl}
            onChange={(e) =>
              setLink((v) => ({ ...v, publicDownloadUrl: e.target.value }))
            }
          />
        </form>
      </section>

      <section className="row my-3">
        <header
          className="col-lg col-12 text-left h5 bannerfont ml-3"
          style={{ fontWeight: 600 }}
        >
          Monday.com Form
        </header>
        <form className="col d-flex flex-column justify-content-left align-items-left shadow-md my-1 rounded">
          <textarea
            type="text"
            placeholder="Place Here Only Iframe Link"
            name="monday.com"
            className="w-100 px-2"
            rows="6"
            cols="30"
            value={link.links}
            onChange={(e) => setLink((v) => ({ ...v, links: e.target.value }))}
          />
        </form>
      </section>
    </section>
  );
};

export default Rendernow;
